// @flow

import countryCodeToCallingCode from './data/countryCodeToCallingCode.json';

export const getSanitizedPhoneCode = (phoneCode: string): string => {
  const isPhoneCodeNumeric: boolean = !!parseInt(phoneCode, 10) || !phoneCode;

  return isPhoneCodeNumeric ? phoneCode : countryCodeToCallingCode[phoneCode];
};

export const getInternationalPhone = (phoneCodeArg: ?string, phoneArg: ?string): string => {
  const phoneCode: string = phoneCodeArg || '';
  const phone: string = phoneArg || '';

  if (phone.startsWith('+')) return phone;

  const sanitizedPhoneCode = getSanitizedPhoneCode(phoneCode);

  return `+${sanitizedPhoneCode} ${phone}`;
};
